import { __decorate } from "tslib";
import { AlgorithmIdentifier } from "@peculiar/asn1-x509";
import { AsnProp, AsnPropTypes, AsnIntegerArrayBufferConverter, OctetString, } from "@peculiar/asn1-schema";
export class CertID {
    constructor(params = {}) {
        this.hashAlgorithm = new AlgorithmIdentifier();
        this.issuerNameHash = new OctetString();
        this.issuerKeyHash = new OctetString();
        this.serialNumber = new ArrayBuffer(0);
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AlgorithmIdentifier })
], CertID.prototype, "hashAlgorithm", void 0);
__decorate([
    AsnProp({ type: OctetString })
], CertID.prototype, "issuerNameHash", void 0);
__decorate([
    AsnProp({ type: OctetString })
], CertID.prototype, "issuerKeyHash", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], CertID.prototype, "serialNumber", void 0);
